import secureApi from "../services/secureApi";

// Get Blog List
export const getBlogs = async (page = 1, limit = 10) => {
  try {
    const response = await secureApi.get(
      `/admin/blog/list?page=${page}&limit=${limit}`,
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching blogs:", error);
    throw error;
  }
};

// Get Blog By Slug/Id
export const getBlogById = async (slug) => {
  try {
    const response = await secureApi.get(`/admin/blog/view/${slug}`);

    return response.data;
  } catch (error) {
    console.error("Error fetching blog:", error);
    throw error;
  }
};

// Add Blog
export const addBlog = async (data) => {
  try {
    const response = await secureApi.post("/admin-upload/blog/add", data);

    return response.data;
  } catch (error) {
    console.error("Error adding blog:", error);
    throw error;
  }
};

// Update Blog
export const updateBlog = async (id, data) => {
  try {
    const response = await secureApi.put(`/admin-upload/blog/edit/${id}`, data);

    return response.data;
  } catch (error) {
    console.error("Error updating blog:", error);
    throw error;
  }
};

export const deleteBlog = async (id) => {
  try {
    const response = await secureApi.delete(`/admin/blog/delete/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting blog:", error);
    throw error;
  }
};
